import creditCardType from "credit-card-type";
import { TFunction } from "i18next";

import { mapCardNetworkEnumMembersToCreditCardTypeCardBrandId } from "cc-tools/helpers";

import { CardNetworkRadioOption } from "chameleon/lib/components";
import { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

import { CardNetwork } from "frontend-client";

export type SelectOption = { value: string; title: string };

export type TranslationListType = Record<string, string | Array<string>>;

export const buildCountryList = (
  t: TFunction<"translation", undefined>,
  targetKeys: string[]
): SelectOption[] => {
  const allCountryList = t("countries.countries", {
    ns: "combined",
    returnObjects: true,
  }) as TranslationListType;
  const formattedList: SelectOption[] =
    mapTranslationsToArrayOfValues(allCountryList);
  return targetKeys.length === 0
    ? formattedList
    : formattedList.filter((item: SelectOption) =>
        targetKeys.includes(item.value)
      );
};

export const mapTranslationsToArrayOfValues = (list?: TranslationListType) => {
  if (!list) return [];
  return Object.entries(list).map(([key, value]) => ({
    value: key,
    title: Array.isArray(value) ? value[0] : value,
  }));
};

export const buildSelectNetworkOptions = (
  t: TFunction<"translation", undefined>,
  possibleCardNetworksApi: Array<CardNetwork> | undefined,
  supportedPaymentTypes: CreditCardNetwork[]
) => {
  if (possibleCardNetworksApi && possibleCardNetworksApi.length > 1) {
    const cardOptions = possibleCardNetworksApi
      ?.map((network) => {
        const cardNetworkEnumMember =
          Object.keys(CardNetwork)[Object.values(CardNetwork).indexOf(network)];

        const cardNetworkType = creditCardType.getTypeInfo(
          mapCardNetworkEnumMembersToCreditCardTypeCardBrandId[
            cardNetworkEnumMember
          ]
        );

        if (
          supportedPaymentTypes.includes(
            cardNetworkType.niceType as CreditCardNetwork
          )
        ) {
          return {
            value: cardNetworkType?.niceType,
            title: t(`cardOptions.${cardNetworkType?.niceType}`),
          };
        }
        return;
      })
      .filter((option) => option !== undefined) as CardNetworkRadioOption[];
    return cardOptions;
  }
  return;
};
